// src/view/scenes/WorldScene.ts
import * as PIXI from 'pixi.js';


export class WorldScene extends PIXI.Container {
    private uiLayer = new PIXI.Container();
    private background: PIXI.Graphics | null = null;
    private titleText: PIXI.Text | null = null;

    constructor(private app: PIXI.Application) {
        super();
        this.addChild(this.uiLayer);
    }

    /**
     * Ініціалізація сцени (викликається в main.tsx)
     */
    public async init() {
        console.log("WorldScene: Ініціалізація...");

        // 1. Створюємо тимчасовий фон
        this.background = new PIXI.Graphics()
            .rect(0, 0, this.app.screen.width, this.app.screen.height)
            .fill(0x1A1714); // «Глибокий торф» (Deep Umber)
            // .fill(0x1F211A); // «Військовий антрацит» (Olive Charcoal)
            // .fill(0x16181D); // «Холодний графіт» (Cool Graphite)
        
        this.uiLayer.addChildAt(this.background, 0);

        // // 2. Додаємо текст заголовка
        // const style = new PIXI.TextStyle({
        //     fontFamily: 'Arial',
        //     fontSize: 36,
        //     fill: '#ffffff',
        //     fontWeight: 'bold',
        // });

        // this.titleText = new PIXI.Text({ text: 'WORLD MAP', style });
        // this.titleText.anchor.set(0.5);
        // this.titleText.x = this.app.screen.width / 2;
        // this.titleText.y = 100;
        // this.uiLayer.addChild(this.titleText);
    }

    /**
     * Очищення при зміні сцени
     */
    public destroy(options?: PIXI.DestroyOptions) {
        console.log("WorldScene: Знищення...");


        const destroyOptions: PIXI.DestroyOptions = {
            children: true,
            texture: false,
        };

        if (typeof options === 'object' && options !== null) {
            Object.assign(destroyOptions, options);
        }

        super.destroy(destroyOptions);
    }
}